<template>
  <v-container class="mx-auto text-center">
    <div v-if="loading" class="text-center">
      <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="d-flex flex-column">
        <video class="mx-auto" controls :src="contentHref"></video>
        <div class="buttons-wrapper">
          <v-btn
            class="ml-auto btn-download"
            color="#1e88e5"
            @click="downloadVideo"
          >
            <span class="color--primary--white">{{
              $t("downloadMeetingVideo")
            }}</span>
          </v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import MeetingVideoViewer from "./mixin/MeetingVideoViewer";

export default {
  mixins: [MeetingVideoViewer]
};
</script>
<style lang="scss" scoped>
.btn-download {
  width: 250px;
  margin-right: 50px;
}
.mx-auto {
  width: 70%;
  margin: 0 auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/meetingvideoviewer/MeetingVideoViewer.vue